<template>
  <div class="w-full pt-2 px-0">
    <h3 class="text-lg pb-2 font-vazir-bold">اطلاعات مخاطب</h3>
    <hr class="dark:hidden" />
    <div class="mt-6 flex justify-center">
      <div class="flex flex-col">
        <div
          class="flex gap-5 flex-wrap justify-center items-center mr-10 mobile:mr-0 tablet:mr-0"
        >
          <div class="mobile:w-full tablet:w-full flex justify-center">
            <img
              src="@/assets/images/profile/user-5.jpg"
              alt="profile pic"
              class="w-20 h-20 rounded-full"
            />
          </div>
          <div class="flex flex-col gap-2 text-slate-600">
            <label for="name" class="font-vazir-bold">نام:</label>
            <input
              type="text"
              name="name"
              v-model="name"
              class="input "
              :class="{ 'border-red-500': errors.name }"
            />
            <span v-if="errors.name" class="text-red-500 text-xs">
              {{ errors.name }}
            </span>
          </div>
          <div class="flex flex-col gap-2 text-slate-600">
            <label for="phone" class="font-vazir-bold">شماره تلفن:</label>
            <input
              type="text"
              name="phone"
              v-model="phone"
              class="input"
              :class="{ 'border-red-500': errors.phone }"
            />
            <span v-if="errors.phone" class="text-red-500 text-xs">
              {{ errors.phone }}
            </span>
          </div>
        </div>
        <div class="mt-14 w-full flex justify-between text-sm">
          <button
            class="bg-white border border-emerald-100 rounded-lg py-2 px-4 text-green-500 hover:bg-emerald-100 transition-colors dark:bg-emerald-500 dark:text-white dark:border-none dark:hover:bg-emerald-600"
            @click="submitForm"
          >
            ثبت
          </button>
          <button
            class="bg-white border border-red-100 rounded-lg py-2 px-4 text-red-500 hover:bg-red-100 transition-colors dark:bg-red-500 dark:text-white dark:border-none dark:hover:bg-red-600"
            @click="closeModal"
          >
            خروج
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { postContactLeads } from "@/services/api/apiServiceLeads";
import { useMutation } from "@tanstack/vue-query";
import Swal from "sweetalert2";
import { ref, defineEmits } from "vue";

const name = ref("");
const phone = ref("");
const errors = ref({ name: "", phone: "" }); // Error messages for validation

const emits = defineEmits(["close"]);

const closeModal = () => {
  emits("close");
  resetForm();
};

const { mutate } = useMutation({
  mutationFn: postContactLeads,
  onSuccess: () => {
    Swal.fire({
      icon: "success",
      title: "مخاطب با موفقیت اضافه شد.",
      showConfirmButton: false,
      timer: 1500,
    });
  },
  onError: () => {
    Swal.fire({
      icon: "error",
      title: "افزودن مخاطب با خطا مواجه شد!",
      showConfirmButton: false,
      timer: 1500,
    });
  },
});

// Function to validate the form fields
const validateForm = () => {
  let isValid = true;

  if (!name.value.trim()) {
    errors.value.name = "نام الزامی است.";
    isValid = false;
  } else {
    errors.value.name = "";
  }

  const phoneRegex = /^[0-9]{10,15}$/; // Validate phone number format
  if (!phone.value.trim()) {
    errors.value.phone = "شماره تلفن الزامی است.";
    isValid = false;
  } else if (!phoneRegex.test(phone.value)) {
    errors.value.phone = "شماره تلفن معتبر نیست.";
    isValid = false;
  } else {
    errors.value.phone = "";
  }

  return isValid;
};

const submitForm = () => {
  if (validateForm()) {
    const userObj = {
      name: name.value,
      phone: phone.value,
    };

    mutate(userObj);
    resetForm();
  }
};

const resetForm = () => {
  name.value = "";
  phone.value = "";
  errors.value = { name: "", phone: "" };
};
</script>

<style>
.input {
  border: 1px solid #e2e8f0;
  padding: 0.5rem;
  border-radius: 0.375rem;
  width: 100%;
  outline: none;
  transition: border-color 0.2s ease-in-out;
}

.input:focus {
  border-color: #3182ce;
}

.input.border-red-500 {
  border-color: #f56565;
}
</style>
